import React from 'react';
import PropTypes from 'prop-types';

const linkCls = 'ft-socialMedia__link';

const SocialMediaItem = ({ id, title, url }) => (
  <li className="ft-socialMedia__listItem">
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`${linkCls} ${linkCls}--${id}`}
    >
      {title}
    </a>
  </li>
);

SocialMediaItem.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default SocialMediaItem;
